
// <link rel="stylesheet" href="dist/basicLightbox.min.css">
// <script src="dist/basicLightbox.min.js"></script>
import * as basicLightbox from 'basiclightbox'
import { createIframe } from './utilities'
/**
* @param {string} src
*/

export class IframeOverlayHandler {
  /**
  * @param {string[]} srcArray
  */
  constructor(srcArray) {
    /**
    * @type {Record<string, HTMLIFrameElement>} url:iframe map.
    */
    this.cache = {}
    /**
     * @type {basicLightbox.BasicLightBox | null}
     */
    this.overlay = null
  
    // Pre-cache(Optimize)
    // Further info on iframe caching: https://stackoverflow.com/questions/17222384/how-to-prefetch-cache-iframe-content
    srcArray.forEach(src => this.cache[src] = createIframe(src))
  }

  /**
 * @param {string} src
 */
  show(src) {
    const cache = this.cache
    const iframe = this.showIFrameOverlay(src, cache)
  
    // Caching
    if (!cache[src]) {
      cache[src] = iframe
    }
  }

  hide() {
    if (this.overlay) {
      this.hide()
      this.overlay = null
    }
  }

  addControls() {
    document.addEventListener('keyup', (ev) => { // keyup OR keydown
      // Close with esc key https://github.com/electerious/basicLightbox/issues/38
      if (ev.key === 'Escape') {
        this.hide()
      }
    })
  }
  
  /**
  * Iframe overlay with ability to use and MANUALLY set cache.
  * @private
  * @param {string} src
  * @param {Record<string, HTMLIFrameElement>} [cache] Cache is provided so can optionally show content quickly.
  */
  showIFrameOverlay(src, cache = {}) {
    // Iframe
    const iframe = cache[src] || createIframe(src)
  
    // Overlay(closable overlay)
    this.showElementAsClosableOverlay(iframe)
  
    return iframe
  }
  
  /**
  * @see https://github.com/electerious/basicLightbox
  * 
  * Demo: https://codepen.io/electerious/pen/rLBvGz
  *
  * Closing:
  * https://github.com/electerious/basicLightbox/issues/43
  * https://github.com/electerious/basicLightbox/issues/41
  * https://github.com/electerious/basicLightbox/issues/38
  *
  * @private
  * @param {Element} element
  */
  showElementAsClosableOverlay(element) {
    this.overlay = null
    const instance = basicLightbox.create(element, {
      // https://github.com/electerious/basicLightbox#options
      closable: true,
    })
    this.overlay = instance
    instance.show(() => {})
    return instance
  }
}